import { Pipe, PipeTransform } from '@angular/core';

/**
 * Creates a text message based on the password strength value
 */
@Pipe({
  name: 'passwordStrengthText'
})
export class PasswordStrengthTextPipe implements PipeTransform {
  transform(pwStrength: number): string {
    switch (pwStrength) {
      case 0:
      case 1:
        return 'Weak';
      case 2:
      case 3:
        return 'Medium';
      case 4:
        return 'Great!';
      default:
        return '';
    }
  }
}

/**
 * Creates a number that can be used as a percentage for the progress meter
 */
@Pipe({
  name: 'passwordStrengthProgress'
})
export class PasswordStrengthProgressPipe implements PipeTransform {
  transform(pwStrength: number): number {
    switch (pwStrength) {
      case 0:
        return 0;
      case 1:
        return 25;
      case 2:
        return 50;
      case 3:
        return 75;
      case 4:
        return 100;
    }
  }
}

/**
 * Creates a string that can be used as a class name or md color attribute
 */
@Pipe({
  name: 'passwordStrengthColor'
})
export class PasswordStrengthColorPipe implements PipeTransform {
  transform(pwStrength: number): string {
    switch (pwStrength) {
      case 0:
      case 1:
        return 'accent';
      case 2:
      case 3:
        return 'warn';
      case 4:
        return 'primary';
      default:
        return '';
    }
  }
}
